import { useCallback, useState } from 'react';
import { esFalloDeVerdad } from './api';

/**
 * EL ESTADO "ESTO NO CARGÓ".
 *
 * La ley ya escrita (`vacio-no-es-lo-mismo-que-fallido`): `catch { setLista([]) }` convierte un
 * error en un vacío creíble. Medido el 2026-09-17 sobre los 94 `useEffect(() => load())` del
 * front, 14 hacían exactamente eso y 23 se tragaban el error sin escribir nada.
 *
 * Esto es la mitad del arreglo —la otra mitad es pintar `<NoCargo/>` en vez del vacío— y existe
 * como pieza compartida para que las 21 pantallas digan lo mismo de la misma forma, en vez de 21
 * inventos parecidos.
 *
 * UNA SESIÓN VENCIDA NO ES UN FALLO: `api.ts` ya mandó a la persona al login y la pantalla se va a
 * desmontar. Marcarla en rojo sería pintar un error encima de algo ya resuelto.
 */
export function useFallo() {
  const [fallo, setFallo] = useState(false);
  const marcar = useCallback((e?: unknown) => {
    if (!esFalloDeVerdad(e)) return;
    setFallo(true);
  }, []);
  const limpiar = useCallback(() => setFallo(false), []);
  return { fallo, marcar, limpiar };
}
